import { motion } from "framer-motion";
import { ASSIST } from "@/data/content";
import { SectionHeader } from "@/components/ui-bits";
import { staggerParent, staggerChild } from "@/components/motion-primitives";

export const WhoWeAssist = () => (
  <section className="relative py-24 md:py-32 bg-background">
    <div className="container mx-auto px-4 md:px-8">
      <SectionHeader
        overline="Who We Assist"
        title="Trusted across every property type"
        subtitle="From single homeowners to shopping centres and industrial parks, we support a broad range of clients."
      />
      <motion.div
        variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
        className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4"
      >
        {ASSIST.map((a, i) => {
          const Icon = a.icon;
          return (
            <motion.div
              key={i} variants={staggerChild} data-testid={`assist-${i}`}
              className="group flex items-center gap-3 rounded-xl border border-slate-200/80 bg-white px-4 py-4 hover:border-secondary/50 hover:shadow-md transition-all duration-300"
            >
              <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-muted text-primary group-hover:bg-secondary group-hover:text-white transition-colors shrink-0">
                <Icon className="w-5 h-5" />
              </span>
              <span className="text-sm font-medium text-slate-700 leading-tight">{a.label}</span>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);
